export default __webpack_public_path__ + "1dd768d01c4c4d0f413d8767b0d36db0.png";